var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elements",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar-icons-V2",
    transform: "translate(-61.000000, -667.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-testing-eb50",
    transform: "translate(61.000000, 667.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "speedometer",
    transform: "translate(3.000000, 4.000000)",
    fill: "#616674"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,11.7 C7.50883118,11.7 6.3,10.4911688 6.3,9 C6.3,7.992 6.849,7.11 7.65,6.651 L16.389,1.593 L11.412,10.215 C10.962,11.097 10.053,11.7 9,11.7 M9,0 C10.629,0 12.15,0.45 13.473,1.188 L11.583,2.277 C10.8,1.971 9.9,1.8 9,1.8 C5.0235498,1.8 1.8,5.0235498 1.8,9 C1.8,10.989 2.601,12.789 3.906,14.085 L3.915,14.085 C4.266,14.436 4.266,15.003 3.915,15.354 C3.564,15.705 2.988,15.705 2.637,15.363 L2.637,15.363 C1.008,13.734 0,11.484 0,9 C0,4.02943725 4.02943725,0 9,0 M18,9 C18,11.484 16.992,13.734 15.363,15.363 L15.363,15.363 C15.012,15.705 14.445,15.705 14.094,15.354 C13.743,15.003 13.743,14.436 14.094,14.085 L14.094,14.085 C15.399,12.78 16.2,10.989 16.2,9 C16.2,8.1 16.029,7.2 15.714,6.39 L16.803,4.5 C17.55,5.85 18,7.362 18,9 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTesting);
export default __webpack_public_path__ + "static/media/ic_testing.14e19a307d3d04e1bcd99f34a1af5223.svg";
export { ForwardRef as ReactComponent };